import {
    GET_TRANSACTION_NETWORK_DEF,
    GET_TRANSACTION_NETWORK_DEF_SUCCESS,
    TRANSACTION_NETWORK_DEF_API_ERROR
} from "./actionTypes"

export const getTransactionNetworkDefList = () => ({
    type: GET_TRANSACTION_NETWORK_DEF,
})

export const getTransactionNetworkDefListSuccess = record => ({
    type: GET_TRANSACTION_NETWORK_DEF_SUCCESS,
    payload: record,
})

export const transactionNetworkDefApiError = error => {
    return {
        type: TRANSACTION_NETWORK_DEF_API_ERROR,
        payload: error,
    }
}
